'use strict';

angular.module('TurneroApp').component('coSidebarExtension', {
    controller: [
        '$state',
        '$sessionStorage',
        '$interval',
        '$mdDialog',
        'seguridadService',
        'generalService',
        '$scope',
        '$timeout',
        function ($state, $sessionStorage, $interval, $mdDialog, seguridadService, generalService, $scope, $timeout) {
            var ctrl = this;
            ctrl.sinConexion = false;
            ctrl.sinConexionTimer = null;
            ctrl.timer = 0;
                        
            //cuando se llama a una conexión
            $scope.$on('BeforeHubConnectionStart', function (event, hub) {
                //si es la primera vez que se conecta o ya estaba conectado entonces doy por hecho que no se conectó hasta que reciba el AfterHubConnectionStart
                if (!ctrl.sinConexion) {
                    //le doy unos segundos antes de mostrar la alerta
                    if (!ctrl.sinConexionTimer)
                        ctrl.sinConexionTimer = $timeout(function () { ctrl.sinConexion = true }, 3000);
                }
            });

            //cuando se conecta al hub oculto el toast
            $scope.$on('AfterHubConnectionStart', function (event, hub) {
                if (ctrl.sinConexionTimer)
                    $timeout.cancel(ctrl.sinConexionTimer);

                ctrl.sinConexion = false;
            });

            //cuando se desconecta el hub muestro el toast
            $scope.$on('AfterHubConnectionClose', function (event, hub) {
                ctrl.sinConexion = true;
            });
        }],
    template: require('./sidebar.html')
});



// WEBPACK FOOTER //
// ./app/components/layout/sidebar/sidebarComponent.js